import React from 'react'

const CourseView = () => {

  return (
    <div>
      <p>
        <button className='btn btn-primary'>CourseView</button>
      </p>
      </div>
    
  );
}

export default CourseView;